export default __webpack_public_path__ + "images/omg_97cd9d.svg";